import React from 'react';
import { generateBemCss } from 'general/js/helpers';

const ScoreCell = ({ childCss, bemList, children }) => {
    const bemCss = generateBemCss('score-cell', bemList);

    return <div className={`${childCss} ${bemCss}`}>{children}</div>;
};

ScoreCell.defaultProps = {
    bemList: ['default', 'has-border'],
    childCss: '',
};

export default ScoreCell;
